import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from '@/layouts/AppLayout';
import { AdminLayout } from '@/layouts/AdminLayout';
import { AdminDashboardPage } from '@/pages/admin/AdminDashboardPage';
import { AdminLoginPage } from '@/pages/admin/AdminLoginPage';
import { CategoryFeedPage } from '@/pages/public/CategoryFeedPage';
import { CategoriesPage } from '@/pages/public/CategoriesPage';
import { HomePage } from '@/pages/public/HomePage';
import { NewsArticlePage } from '@/pages/public/NewsArticlePage';
import { SearchPage } from '@/pages/public/SearchPage';
import { NotFoundPage } from '@/pages/system/NotFoundPage';

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/noticia/:slug', element: <NewsArticlePage /> },
      { path: '/categoria/:categorySlug', element: <CategoryFeedPage /> },
      { path: '/categorias', element: <CategoriesPage /> },
      { path: '/buscar', element: <SearchPage /> }
    ]
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [{ index: true, element: <AdminDashboardPage /> }]
  },
  { path: '*', element: <NotFoundPage /> }
]);
